export const HOUR_HEIGHT = 120; 
export const MINUTE_HEIGHT = HOUR_HEIGHT / 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;

export const TIME_BLOCK_MIN_HEIGHT = 30; 
export const TIME_BLOCK_PADDING = 2; 

export const CALENDAR_HEADER_HEIGHT = 50; 
export const TIME_LABEL_WIDTH = 50; 

export const SNAP_INTERVAL = 5; 
export const DEFAULT_DURATION = 15; 